import { render, staticRenderFns } from "./rejected-dialog.vue?vue&type=template&id=699813da&scoped=true&"
import script from "./rejected-dialog.vue?vue&type=script&lang=js&"
export * from "./rejected-dialog.vue?vue&type=script&lang=js&"
import style0 from "./rejected-dialog.vue?vue&type=style&index=0&id=699813da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699813da",
  null
  
)

export default component.exports